import { render, staticRenderFns } from "./MaterialDetail.vue?vue&type=template&id=f7c227cc&scoped=true&"
import script from "./MaterialDetail.vue?vue&type=script&lang=js&"
export * from "./MaterialDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c227cc",
  null
  
)

export default component.exports